import { render, staticRenderFns } from "./OrganizationDetailsLandingPage.vue?vue&type=template&id=946d0860&scoped=true"
import script from "./OrganizationDetailsLandingPage.vue?vue&type=script&lang=js"
export * from "./OrganizationDetailsLandingPage.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDetailsLandingPage.vue?vue&type=style&index=0&id=946d0860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946d0860",
  null
  
)

export default component.exports